var map = {
	"./buero_praxis.js": 86,
	"./business.js": 87,
	"./einzelhandel.js": 88,
	"./eventbus.js": 9,
	"./flat.js": 89,
	"./house.js": 90,
	"./investment.js": 91,
	"./lager_produktion.js": 92,
	"./parking.js": 93,
	"./plot.js": 94,
	"./rest.js": 95,
	"./villa.js": 96
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28;


//////////////////
// WEBPACK FOOTER
// ./src/data ^\.\/.*\.js$
// module id = 28
// module chunks = 0